.stack {
  display: inline-flex;
  flex-direction: row-reverse;
}
